




































import { Component, Prop, Vue } from "vue-property-decorator";
import AsesmenRisikoJatuhInput from "@/components/AsesmenRisikoJatuhInput.vue";
import AsesmenRisikoJatuh from "@/services/AsesmenRisikoJatuh";
import moment from "moment";

interface RisjatRecord {
  id: number;
  metode: string;
  skor: number | null;
  waktu_periksa: string;
  question?: unknown[];
}

interface RisjatInputRef {
  metode: string;
  tug: number | null;
  categVal: Record<string, Record<string, unknown>>;
  save(): Promise<RisjatRecord | undefined>;
}

@Component({
  components: { AsesmenRisikoJatuhInput },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class RisikoJatuhSection extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) readonly disabled!: boolean;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  prefillValue: RisjatRecord | null = null;
  loading = false;

  get prefilled(): boolean {
    return !!this.prefillValue?.id;
  }

  async mounted() {
    await this.loadLatest();
  }

  async loadLatest() {
    if (!this.register) return;
    this.loading = true;
    try {
      const resp = await AsesmenRisikoJatuh.getByRegister(this.register, {
        page: 1,
        per_page: 1,
        sort_by: "waktu_periksa",
        sort_desc: true
      });
      const list = resp?.data || [];
      this.prefillValue = list.length > 0 ? list[0] : null;
      this.$emit(
        "input",
        this.prefillValue
          ? {
              id: this.prefillValue.id,
              skor: this.prefillValue.skor,
              metode: this.prefillValue.metode
            }
          : {}
      );
    } catch {
      this.prefillValue = null;
    } finally {
      this.loading = false;
    }
  }

  async onSaved() {
    await this.loadLatest();
  }

  // Dipanggil parent (AsesmenKeperawatanIntensifPage) saat tombol Simpan
  // di page ditekan. Mode "attach" menyembunyikan tombol Simpan internal,
  // jadi parent harus eksplisit men-trigger save lewat ref ini.
  async save(): Promise<RisjatRecord | null> {
    if (this.readOnly) return null;
    const inp = this.$refs.risjatInput as unknown as RisjatInputRef | undefined;
    if (!inp || typeof inp.save !== "function") return null;

    // Lewati kalau form benar-benar kosong (tidak ada prefill & tidak ada
    // input baru) — supaya tidak membuat record skor=null.
    const metode = inp.metode;
    const hasInput =
      inp.tug !== null ||
      Object.keys(inp.categVal?.[metode] ?? {}).length > 0;
    if (!hasInput) return null;

    return (await inp.save()) ?? null;
  }

  formatTanggal(s: string): string {
    return s ? moment(s).format("DD-MM-YYYY HH:mm") : "-";
  }

  parseMetodeText(m: string): string {
    if (m === "mfs") return "Morse Fall Scale";
    if (m === "hd") return "Humpty Dumpty";
    if (m === "tug") return "Time Up and Go";
    return "-";
  }
}
